import angular from 'angular'

import template from '../../../templates/shared/wr-info-field.html'

/**
 * Directive for a single information field (e.g. outlet name in a register closure or brand in product details).
 *
 * @module webregister.directives.wrInfoField
 */
angular.module('webregister.directives').directive('wrInfoField', function () {
  return {
    scope: {
      label: '<',
      value: '<',
    },
    transclude: true,
    restrict: 'EA',
    template,
    controllerAs: 'infoFieldCtrl',
    bindToController: true,
    link(scope, $element, iAttrs) {
      iAttrs.$addClass('wr-info-field')
    },
    controller(this: $TSFixMe, $attrs) {
      /**
       * Whether the `value` attribute has been explicitly declared. If false then the use of ng-transclude
       * is assumed (i.e. the value of the field is HTML included inside the `<wr-info-field></wr-info-field>`
       * tag).
       *
       * @property hasValueAttribute
       * @type {Boolean}
       */
      this.hasValueAttribute = $attrs.$attr.hasOwnProperty('value')
    },
  }
})
